import Mustache from 'mustache';
import carouselTemplate from '../templates/carousel.mustache.html';

const {
  carouselStories,
  preferredTopic,
  preferredTopicLink,
  storylineTitle,
} = window.carouselData;

const storiesWithIndex = carouselStories.map((story, index) => {
  return {
    ...story,
    index,
  };
});

const showArrowWrapper = storiesWithIndex.length > 3;

const carouselContents = Mustache.render(carouselTemplate, {
  carouselStories: storiesWithIndex,
  preferredTopic,
  preferredTopicLink,
  storylineTitle,
  showArrowWrapper,
});

/**
 * Changes the left carousel arrow on the first item and changes the right arrow on the last item
 * @param {int} currentPos - the position of the first elemenet of the slider
 */
const changeArrows = (currentPos) => {
  // Accounts for not having a topic card when there is a storylne
  const arrowsLimit = storylineTitle ? 3 : 2;
  if (currentPos === 0) {
    $('.js-carousel-arrow-left')
      .addClass('carousel-lighten');
    $('.js-carousel-arrow-right')
      .removeClass('carousel-lighten');
  } else if (currentPos >= carouselStories.length - arrowsLimit) {
    $('.js-carousel-arrow-right')
      .addClass('carousel-lighten');
    $('.js-carousel-arrow-left')
      .removeClass('carousel-lighten');
  } else {
    $('.js-carousel-arrow-left, .js-carousel-arrow-right')
      .removeClass('carousel-lighten');
  }
};

function setArrowCssEventListener(carouselId, carouselGlider) {
  // Sets the event listener to update the arrow css for each carousel
  $(`${carouselId} .js-carousel-wrapper`).on('scroll', () => {
    changeArrows(carouselGlider.slide);
  });
  $(carouselId).on('click', '.js-carousel-arrow-left, .js-carousel-arrow-right', () => {
    changeArrows(carouselGlider.slide);
  });
  $(carouselId).on('focus', '.js-carousel-item__link', () => {
    changeArrows(carouselGlider.slide);
  });
}

function getGliderSettings(carouselId) {
  // We break out the glider settings into a function because
  // the arrows css selector needs to be unique for each glider.
  const gliderSettings = {
    exactWidth: true,
    itemWidth: 216,
    slidesToScroll: 1,
    duration: 3,
    arrows: {
      prev: `${carouselId} .js-carousel-arrow-left`,
      next: `${carouselId} .js-carousel-arrow-right`,
    },
    responsive: [
      {
        breakpoint: 480, // css small breakpoint
        settings: {
          exactWidth: true,
          itemWidth: 241,
        },
      },
    ],
  };

  return gliderSettings;
}

function setStandardArticleGliders() {
  // Sets the carousel glider for standard width articles
  const desktopCarouselGlider = new window.Glider(document.querySelector('#desktop-carousel .js-carousel-wrapper'), getGliderSettings('#desktop-carousel'));
  setArrowCssEventListener('#desktop-carousel', desktopCarouselGlider);

  // We check that the mobile carousel is there before setting its glider - because it's possible
  // that the desktop carousel is there but not the mobile carousel. This is because the
  // desktop carousel uses the 3rd inline ad position and the mobile carousel uses the
  // 4th inline ad position - so it can happen that an article is long enough for the
  // 3rd position but not the 4th position.
  if ($('#mobile-carousel').length > 0) {
    const mobileCarouselGlider = new window.Glider(document.querySelector('#mobile-carousel .js-carousel-wrapper'), getGliderSettings('#mobile-carousel'));
    setArrowCssEventListener('#mobile-carousel', mobileCarouselGlider);
  }
}

function setFullWidthArticleGliders() {
  // Sets the carousel glider for standard width articles
  const fullWidthCarouselGlider = new window.Glider(document.querySelector('#full-width-carousel .js-carousel-wrapper'), getGliderSettings('#full-width-carousel'));

  setArrowCssEventListener('#full-width-carousel', fullWidthCarouselGlider);
}

$(window).on('load', () => {
  if ($('.storylines-carousel-wrapper').length > 0) {
    $('.storylines-carousel-wrapper').html(carouselContents);

    if ($('.full-width').length > 0) {
      setFullWidthArticleGliders();
    } else {
      setStandardArticleGliders();
    }
  }
});
